// import components
import { styled, Box, ListItem, BoxProps } from '@mui/material';

export const StyledDutyLineList = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  width: '100%',
  borderBottom: `1px solid ${theme.palette.divider}`,

  '&.MuiAutocomplete-option': {
    justifyContent: 'space-between'
  },
  ':last-child': { borderBottom: 'none' }
}));

export const StyledDutyLineBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'right',
  color: theme.palette.text.secondary
}));

export const StyledPeriodTimeBox = styled(Box)<BoxProps>(() => ({
  fontSize: '12px',
  width: '100px'
}));

export const StyledOptionLabelBox = styled(Box)<BoxProps>(() => ({
  width: '100%'
}));
